import { render, staticRenderFns } from "./DetailActionAndMeta.vue?vue&type=template&id=237f21f8&scoped=true"
import script from "./DetailActionAndMeta.vue?vue&type=script&lang=js"
export * from "./DetailActionAndMeta.vue?vue&type=script&lang=js"
import style0 from "./DetailActionAndMeta.vue?vue&type=style&index=0&id=237f21f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237f21f8",
  null
  
)

export default component.exports